<template lang="pug">

  form-group-row(:form="form" :label="label" name="password_confirmation" :required="required")
    form-input(:form="form" name="password_confirmation" type="password")
    span.help-block.text-muted(v-if="hint") {{ hint }}

</template>

<script>

export default {
  name: 'user-input-password-confirmation',

  props: {
    label: {
      type: String,
      default: 'Password confirmation',
    },
    required: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: '',
    }
  },

  data: () => ({
    form: null,
  }),

  async created() {
    this.form = this.$parent.form;
    this.form.password_confirmation = '';
  },
}

</script>
